import { Trees, FileText, Calculator, Leaf, Sun, Droplets, Palette, CalendarDays } from "lucide-react";
import IndustryPlaceholderPage from "@/components/industry/IndustryPlaceholderPage";

const LandscapingIndustry = () => (
  <IndustryPlaceholderPage
    name="Landscaping & Groundskeeping"
    fullySupported={false}
    icon={Trees}
    iconColor="text-success"
    iconBg="bg-[hsl(var(--success)/0.1)]"
    headline="Landscaping Proposals"
    tagline="in Minutes"
    description="Sentinel Forge helps landscaping and groundskeeping companies create professional service proposals, seasonal contracts, and maintenance agreements — all from one platform."
    valueProps={[
      { title: "Win More Contracts", description: "Build detailed landscaping proposals with service breakdowns, material costs, and seasonal schedules that impress property managers and homeowners." },
      { title: "Automate Your Workflow", description: "Stop writing proposals from scratch. Use industry-specific templates to generate polished bids in minutes, not hours." },
      { title: "Built for Green Industry", description: "Templates designed for mowing, hardscaping, irrigation, snow removal, and seasonal maintenance — by people who know the trade." },
    ]}
    features={[
      { icon: Calculator, label: "Material & Labor Calculators" },
      { icon: CalendarDays, label: "Seasonal Scheduling" },
      { icon: FileText, label: "PDF Proposals" },
      { icon: Leaf, label: "Service Scope Templates" },
      { icon: Trees, label: "Property Mapping" },
      { icon: Sun, label: "Seasonal Contracts" },
      { icon: Droplets, label: "Irrigation Planning" },
      { icon: Palette, label: "Custom Branding" },
    ]}
    benefits={[
      "Create property-specific proposals with service frequency, crew size, and material lists",
      "Auto-calculate costs based on square footage, service type, and seasonal frequency",
      "Generate branded proposals with property photos and site maps",
      "Send contracts with digital signatures for fast client approval",
      "Track proposals, active contracts, and recurring service agreements",
      "Support seasonal and year-round maintenance packages",
    ]}
    proposalTemplates={[
      "Residential Lawn Maintenance",
      "Commercial Grounds Maintenance",
      "Hardscape & Patio Installation",
      "Irrigation System Installation",
      "Snow & Ice Removal Services",
    ]}
    contractTemplates={[
      "Seasonal Maintenance Agreement",
      "Year-Round Grounds Contract",
      "Hardscape Project Contract",
      "Snow Removal Service Agreement",
    ]}
    faq={[
      { q: "What is Sentinel Forge for landscaping?", a: "Sentinel Forge is a proposal and contract platform built for landscaping and groundskeeping businesses. It helps you create professional service proposals, calculate job costs, and send digital contracts to clients." },
      { q: "Can I build proposals for different service types?", a: "Yes. The platform includes templates for lawn maintenance, hardscaping, irrigation, snow removal, and more — each with relevant service scopes and pricing models." },
      { q: "How does cost calculation work?", a: "You define service areas, materials, labor rates, and frequency. The system automatically calculates total project and recurring costs including seasonal adjustments." },
      { q: "Can I manage recurring maintenance contracts?", a: "Yes. You can create seasonal or year-round maintenance agreements with automatic renewal templates and scheduling." },
      { q: "Do clients need an account to sign contracts?", a: "No. Clients receive a secure link to review and digitally sign contracts without creating an account." },
      { q: "Can I add my company's branding?", a: "Yes. Your logo, company name, and custom terms appear on every proposal and contract you generate." },
      { q: "When will landscaping be available?", a: "We're building it now. Join the waitlist to get notified when the landscaping module launches." },
      { q: "How do I get support?", a: "Reach our team at support@sentinelforge.com or through the in-app support ticket system." },
    ]}
    ctaHeadline="Ready to grow your landscaping business?"
    ctaDescription="Join landscaping companies preparing to automate proposals and client contracts with Sentinel Forge."
  />
);

export default LandscapingIndustry;
